module.exports = __webpack_public_path__ + "img/haiti.39b5081b.svg";